import { lovemoFeatures } from '@/mocks/lovemoContent';
import LovemoSectionHeading from '@/components/feature/LovemoSectionHeading';

const toneMap: Record<'primary' | 'accent' | 'secondary', string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function LovemoFeatures() {
  return (
    <section id="lovemo-features" className="bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-24">
        <LovemoSectionHeading
          eyebrow="核心功能"
          title="为什么大家都在用Lovemo"
          desc="不只是聊天机器人，Lovemo更像一个真正愿意听你说话的伙伴。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {lovemoFeatures.map((feature) => (
            <article
              key={feature.id}
              className="lovemo-reveal group rounded-lg border border-background-200/70 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${toneMap[feature.tone]}`}
              >
                <i className={feature.icon} aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{feature.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}